<template>
  <v-card class="left-vertical-card">
    <div class="d-flex bg-titre">
      <div class="align-self-center pl-3 mr-auto">
        <div class="d-flex flex-column">
          <div class="titre-h3 secondary--text ">
            Itinéraire technique
          </div>
          <div class="titre-h5 secondary--text ">
            Traitement <span class="secondary--text align-self-center ">({{ traitements[0].typeCulture.nom }})</span>
          </div>
        </div>
      </div>
      <v-btn
        class="align-self-center"
        text
        @click="onClose"
      >
        <v-icon color="secondary">
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <div class="d-flex flex-column mt-3">
      <v-card
        v-for="traitement in traitements"
        :key="traitement.id"
        class="pa-2 mb-2 background mx-4"
      >
        <div class="d-flex justify-space-between">
          <div class="secondary--text titre-h5">
            {{ traitement.typeRubrique.libelleSousRubrique }}
            <v-chip
              v-if="traitement.typeRubrique.statut === 'OBLIGATOIRE'"
              small
              
              color="secondary"
            >
              <span class="text-lowercase">
                {{ traitement.typeRubrique.statut | capitalize }}
              </span>
            </v-chip>
          </div>
          <div class="d-flex justify-space-around">
            <AgrButton
              icon
              @click="onOpenUpdateParametreModal(traitement)"
            >
              <v-icon color="grey darken-2">
                mdi-pencil-outline
              </v-icon>
            </AgrButton>
            <AgrButton
              v-if="traitement.typeRubrique.statut === 'SUPPRIMABLE'"
              icon
              @click="onOpenDeleteParametreModal(traitement)"
            >
              <v-icon color="grey darken-2">
                mdi-delete-outline
              </v-icon>
            </AgrButton>
          </div>
        </div>
        <div
          v-if="!traitement.typeRubrique.isValeurEconomiqueUniquement"
          class="d-flex justify-space-between"
        >
          <div class="texte py-0 texte-gris-fonce">
            Coût (pression faible)
          </div>
          <div class="align-self-center texte py-0 secondary--text">
            {{ traitement.valeurMin != null ? traitement.valeurMin : '-' }} €/ha
          </div>
        </div>
        <div
          v-if="!traitement.typeRubrique.isValeurEconomiqueUniquement"
          class="d-flex justify-space-between"
        >
          <div class="texte py-0 texte-gris-fonce">
            Coût (pression moyenne)
          </div>
          <div class="align-self-center texte py-0 secondary--text">
            {{ traitement.valeurDefaut != null ? traitement.valeurDefaut : '-' }} €/ha
          </div>
        </div>
        <div
          v-if="!traitement.typeRubrique.isValeurEconomiqueUniquement"
          class="d-flex justify-space-between"
        >
          <div class="texte py-0 texte-gris-fonce">
            Coût (pression forte)
          </div>
          <div class="align-self-center texte py-0 secondary--text">
            {{ traitement.valeurMax != null ? traitement.valeurMax : '-' }} €/ha
          </div>
        </div>
        <div
          v-if="traitement.typeRubrique.isValeurEconomiqueUniquement"
          class="d-flex justify-space-between"
        >
          <div class="texte py-0 texte-gris-fonce">
            Coût
          </div>
          <div class="align-self-center texte py-0 secondary--text">
            {{ traitement.valeurEconomique != null ? traitement.valeurEconomique : '-' }} €/ha
          </div>
        </div>
        <div
          v-if="traitement.pressionValeurDefaut && !traitement.typeRubrique.isValeurEconomiqueUniquement"
          class="d-flex justify-space-between"
        >
          <div class="texte py-0 texte-gris-fonce">
            Pression par défaut
          </div>
          <div class="align-self-center texte py-0 secondary--text">
            {{ traitement.pressionValeurDefaut ? traitement.pressionValeurDefaut : '-' }}
          </div>
        </div>
      </v-card>
      <div class="d-flex justify-space-between my-3 mx-4">
        <AgrButton
          outlined
          @click="onOpenNouveauParametreModal()"
        >
          Ajouter un traitement
        </AgrButton>
        <AgrButton
          outlined
          @click="onClose()"
        >
          Fermer
        </AgrButton>
      </div>
    </div>
    <v-dialog
      v-if="isUpdateParametreModalOpen"
      v-model="isUpdateParametreModalOpen"
      width="500"
    >
      <UpdateParametreModal
        :parametre="parametre"
        is-rubrique-traitement
        :type-culture="traitements[0].typeCulture"
        :type-rubrique="traitements[0].typeRubrique"
        :unite="'€/ha'"
        @close="closeModalNouveauParametre()"
        @updatedParametre="updatedParametre"
      />
    </v-dialog>
    <v-dialog
      v-model="isConfirmDeleteParametreModalOpen"
      persistent
      width="500"
    >
      <ConfirmModal
        title="Confirmation"
        cancel-text="Non"
        confirm-text="Oui"
        @cancel="isConfirmDeleteParametreModalOpen=false"
        @confirm="confirmDeleteParametre()"
      >
        Souhaitez-vous vraiment supprimer ce paramètre ?
      </ConfirmModal>
    </v-dialog>
  </v-card>
</template>

<script>
import { AgrButton } from '@agrial/ui'
import ConfirmModal from '@/components/modal/confirm-modal.vue'
import UpdateParametreModal from './update-parametre-modal.vue'
import { mapActions } from 'vuex'

export default {
  name: 'UpdateTraitementModal',
  components: {AgrButton, ConfirmModal, UpdateParametreModal},
  props: {
    traitements: {
      type: Array,
      default: null
    }
  },

  data () {
    return {
      loading: false,
      erreur: null,
      isUpdateParametreModalOpen: false,
      isConfirmDeleteParametreModalOpen: false,
      parametre: null,
      rules: {
        required: value => (value !== null && value !== '') || 'Champ requis',
      }
    }
  },

  methods: {
    ...mapActions({
      deleteAdminComparateurParametreMarge: 'comparateurMarge/deleteAdminComparateurParametreMarge'
    }),
    onClose () {
      this.$emit('close')
    },
    onOpenNouveauParametreModal () {
      this.isUpdateParametreModalOpen = true
      this.parametre = null
    },
    closeModalNouveauParametre () {
      this.isUpdateParametreModalOpen = false
    },
    onOpenUpdateParametreModal (value) {
      this.parametre = value
      this.isUpdateParametreModalOpen = true
    },
    onOpenDeleteParametreModal (value) {
      this.parametre = value
      this.isConfirmDeleteParametreModalOpen = true
    },
    confirmDeleteParametre () {
      this.deleteAdminComparateurParametreMarge(this.parametre)
      .then(()=> this.$emit('updatedParametre', this.traitements[0].typeCulture.id))
      this.isConfirmDeleteParametreModalOpen = false
      this.parametre = null
    },
    updatedParametre () {
      this.$emit('updatedParametre', this.traitements[0].typeCulture.id)
      this.isUpdateParametreModalOpen = false
    }
  }
}
</script>
<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
}

.background {
  background: #EFF0E1;
}

.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}

.input-number {
  width: 100%;
}
</style>
